import { render, staticRenderFns } from "./MainViewCollection.vue?vue&type=template&id=51d174b5&scoped=true&"
import script from "./MainViewCollection.vue?vue&type=script&lang=js&"
export * from "./MainViewCollection.vue?vue&type=script&lang=js&"
import style0 from "./MainViewCollection.vue?vue&type=style&index=0&id=51d174b5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d174b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
